export enum BrowserType {
  UNKNOWN,
  CHROME,
  FIREFOX,
  SAFARI,
  OPERA,
  EDGE,
  IE
}
